/**
 * Site-wide contact form popup.
 *
 * Opens template-parts/partials/forms/contact-form-popup.php in Magnific Popup
 * and posts the Zymplify form over AJAX, mirroring the gated popup used by the
 * cta-items block.
 */
(function ($) {
  var POPUP_SELECTOR = "#contact-form-popup";
  // Matches a bare `#contact-form-popup` as well as the absolute form the
  // WordPress/ACF link pickers often save (`https://site.com/page/#contact-form-popup`).
  var TRIGGER_SELECTOR =
    '[href$="#contact-form-popup"], [data-popup="contact"], .contact-form-trigger';
  var ENDPOINT = "https://zymplify.com/embed/contact_process.php";

  /**
   * Email validation (same pattern the Zymplify embed ships with).
   */
  function isValidEmail(str) {
    var regex =
      /^[-_.a-z0-9]+@(([-a-z0-9]+\.)+(ad|ae|aero|af|ag|ai|al|am|an|ao|aq|ar|arpa|as|at|au|aw|az|ba|bb|bd|be|bf|bg|bh|bi|biz|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|com|coop|cr|cs|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|edu|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gh|gi|gl|gm|gn|gov|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|in|info|int|io|iq|ir|is|it|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mil|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|museum|mv|mw|mx|my|mz|na|name|nc|ne|net|nf|ng|ni|nl|no|np|nr|nt|nu|nz|om|org|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|pro|ps|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw)|(([0-9][0-9]?|[0-1][0-9][0-9]|[2][0-4][0-9]|[2][5][0-5])\.){3}([0-9][0-9]?|[0-1][0-9][0-9]|[2][0-4][0-9]|[2][5][0-5]))$/i;
    return regex.test(str);
  }

  /**
   * Fire-and-forget tracking ping so Zymplify attributes the submission.
   */
  function makeCorsRequest(
    contactId,
    clientId,
    origin,
    engagement,
    campaign,
    channel,
  ) {
    var url =
      "https://ds360.co/track/update.php?c=" +
      contactId +
      "&id=" +
      clientId +
      "&origin=" +
      origin +
      "&e=" +
      engagement +
      "&ca=" +
      campaign +
      "&ch=" +
      channel;

    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;

    if ("withCredentials" in xhr) {
      xhr.open("GET", url, true);
    } else if (typeof XDomainRequest !== "undefined") {
      xhr = new XDomainRequest();
      xhr.open("GET", url);
    } else {
      return;
    }

    xhr.onload = function () {};
    xhr.onerror = function () {};
    xhr.send();
  }

  /**
   * Mark a field as invalid by flagging its label, the way Zymplify does.
   */
  function flagField($form, $field) {
    $('label[for="' + $field.attr("id") + '"]', $form).addClass("empty");
    $field.closest(".form-group").addClass("form-group--error");
  }

  /**
   * Is a single field filled in acceptably? Shared by the live Submit toggle
   * and the on-submit validation so the two can never disagree.
   */
  function isFieldValid($field) {
    var type = $field.attr("type");
    var name = $field.attr("name");
    var val = $field.val();

    if (type === "checkbox" || type === "radio") {
      return !!$(
        'input[name="' + name + '"]:checked',
        $field.closest("form"),
      ).length;
    }

    if (val === null || $.trim(val) === "" || val === "- Select -") {
      return false;
    }

    if (name === "email" || name === "email_address") {
      return isValidEmail($.trim(val));
    }

    return true;
  }

  /**
   * Keep Submit greyed out until every required field passes.
   */
  function updateSubmitState($form) {
    var ready = true;

    $form.find(".form_field.required").each(function () {
      if (!isFieldValid($(this))) {
        ready = false;
        return false;
      }
    });

    $form
      .find('input[type="button"]')
      .prop("disabled", !ready)
      .attr("aria-disabled", ready ? "false" : "true");

    return ready;
  }

  /**
   * Read the form into a plain object, flagging anything invalid as it goes.
   *
   * @returns {{data: Object, errors: Number}}
   */
  function collectFormData($form) {
    var data = {};
    var errors = 0;

    $form.find(".form_field, select").each(function () {
      var $field = $(this);
      var type = $field.attr("type");
      var name = $field.attr("name");
      var val = $field.val();
      var isEmailField = name === "email" || name === "email_address";
      var required = $field.hasClass("required");

      if (type === "checkbox" || type === "radio") {
        if (
          required &&
          !$('input[name="' + name + '"]:checked', $form).length
        ) {
          flagField($form, $field);
          errors++;
        } else if ($field.is(":checked")) {
          data[name] = val;
        }
        return;
      }

      if (type === "hidden") {
        data[name] = val;
        return;
      }

      var isEmpty = val === "" || val === null || val === "- Select -";

      if (required && isEmpty) {
        flagField($form, $field);
        errors++;
        return;
      }

      if (isEmailField && !isEmpty && !isValidEmail(val)) {
        flagField($form, $field);
        errors++;
        return;
      }

      data[name] = val;
    });

    return { data: data, errors: errors };
  }

  /**
   * Reset validation state so a reopened popup starts clean.
   */
  function resetPopupState($popup) {
    $popup.find("label").removeClass("empty");
    $popup.find(".form-group").removeClass("form-group--error");
    $popup.find(".contact-form__message").html("").removeClass("error");
    updateSubmitState($popup.find("form"));
  }

  function openPopup() {
    // Say which piece is missing rather than failing silently - a dead trigger
    // is otherwise indistinguishable from a missing script or missing markup.
    if (!$(POPUP_SELECTOR).length) {
      window.console &&
        console.warn(
          "[contact-form-popup] " +
            POPUP_SELECTOR +
            " is not on the page. Check that footer.php renders " +
            "template-parts/partials/forms/contact-form-popup.php."
        );
      return;
    }

    if (!$.magnificPopup) {
      window.console &&
        console.warn(
          "[contact-form-popup] Magnific Popup did not load, so the popup " +
            "cannot open. Check the magnificpopup script enqueue."
        );
      return;
    }

    $.magnificPopup.open({
      items: { src: POPUP_SELECTOR, type: "inline" },
      closeBtnInside: true,
      mainClass: "mfp-contact-popup",
      callbacks: {
        open: function () {
          resetPopupState($(this.content));
        },
      },
    });
  }

  /**
   * Allow `?popup=contact` to open the form straight from a campaign URL.
   */
  function checkUrlPopupTrigger() {
    if (typeof URLSearchParams === "undefined") {
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var requested = params.get("popup") || params.get("show-popup");

    if (!requested) {
      return;
    }

    requested = requested.replace(/^['"]|['"]$/g, "").trim();

    var trigger = $(POPUP_SELECTOR).data("popup-trigger");

    if (requested === trigger || requested === "contact-form-popup") {
      openPopup();
    }
  }

  $(document).ready(function () {
    $(document).on("click", TRIGGER_SELECTOR, function (e) {
      e.preventDefault();
      openPopup();
    });

    // Clear a field's error state as soon as the visitor corrects it, and
    // re-test the form so Submit ungreys the moment the last field is valid.
    // `change` also covers Select2, which re-fires it on the original select.
    $(document).on(
      "input change keyup",
      POPUP_SELECTOR + " .form_field",
      function () {
        var $field = $(this);
        $field.closest(".form-group").removeClass("form-group--error");
        $('label[for="' + $field.attr("id") + '"]').removeClass("empty");
        updateSubmitState($field.closest("form"));
      },
    );

    $(document).on(
      "click",
      POPUP_SELECTOR + ' form input[type="button"]',
      function (e) {
        e.preventDefault();

        var $button = $(this);
        var $form = $button.closest("form");
        var $popup = $button.closest(POPUP_SELECTOR);
        var $message = $popup.find(".contact-form__message");
        var redirectUrl = $popup.data("redirect-url");

        $button.attr("disabled", "disabled");
        $form.find("label").removeClass("empty");
        $form.find(".form-group").removeClass("form-group--error");
        $message.html("").removeClass("error");

        var collected = collectFormData($form);

        if (collected.errors > 0) {
          $message.addClass("error").html("Please fill in all required fields");
          updateSubmitState($form);
          return;
        }

        $.ajax({
          url: ENDPOINT,
          data: { post_arr: collected.data },
          type: "POST",
          dataType: "json",
          crossDomain: true,
          success: function (response) {
            if (parseInt(response.SUCCESS, 10) !== 1) {
              $message
                .addClass("error")
                .html("There was an error. Please try again.");
              updateSubmitState($form);
              return;
            }

            var campaign =
              parseInt($form.find('[name="campaignId"]').val(), 10) || "";
            var channel =
              parseInt($form.find('[name="channel"]').val(), 10) || "";
            var parts = window.location.href.split("/");
            var domain = parts[0] + "//" + parts[2];

            makeCorsRequest(
              response.CID,
              response.CL,
              domain,
              response.E,
              campaign,
              channel,
            );

            if (redirectUrl) {
              window.location.href = redirectUrl;
              return;
            }

            $form[0].reset();
            $message.html(
              "Thank you. A member of our team will be in touch shortly.",
            );
            updateSubmitState($form);
          },
          error: function () {
            $message
              .addClass("error")
              .html("There was an error. Please try again.");
            updateSubmitState($form);
          },
        });
      },
    );

    checkUrlPopupTrigger();
  });
})(jQuery);
